import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useStore from "../../store";
import withAuth from "../Auth/withAuth";

function TeachCourses() {
  const navigate = useNavigate();

  const { logout, setPageTitle, isLoggedIn, data, tenantId } = useStore(
    (state) => state
  );
  useEffect(() => {
    setPageTitle("My Courses");
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      logout();
      navigate(`/?tenantId=${tenantId}`);
    }
  }, []);

  return (
    <div>
      <iframe
        title="my-iframe"
        width="100%"
        height="1000px"
        src={`https://lom.eduedges.com/teach-courses?id_token=${data.idToken.jwtToken}&access_token=${data.accessToken.jwtToken}&tenant_id=${tenantId}`}
      ></iframe>
    </div>
  );
}

export default withAuth(TeachCourses);
